import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IDashboardDto } from '../models';

@Injectable()
export class DashboardService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getDashboardDetails(id: number): Observable<IDashboardDto> {
    return this.get(`admin/dashboard/${id}`);
  }

  public updateServices(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/dashboard/${id}`, null);
  }
}
